import React from "react";
import { Container, Alert, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { PAYMENT } from "../../api/urls";
import axiosInstance from "../../api/axiosRest";
import { toast } from 'react-toastify';

export default function OnboardingRefresh() {
  const navigate = useNavigate();

  const handleTryAgain = async () => {
    try {
      const response = await axiosInstance.post(PAYMENT.CREATE_CONNECTED_ACCOUNT);
      window.location.href = response.data.url;
    } catch (error) {
      toast.error("Failed to restart onboarding. Please try again later.");
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Card className="text-center" style={{ maxWidth: "500px", width: "100%" }}>
        <Card.Body className="p-5">
          <div className="text-warning mb-3" style={{ fontSize: '4rem' }}>⚠️</div>
          <Card.Title className="h3 mb-3">Setup Interrupted</Card.Title>
          <Card.Text className="mb-4">
            It looks like your payout account setup was interrupted or needs to be refreshed. 
            Don't worry - this sometimes happens and is easy to fix.
          </Card.Text>
          
          <Alert variant="warning" className="text-start">
            <Alert.Heading className="h6">What Happened?</Alert.Heading>
            <p className="mb-2 small">
              This usually occurs when the setup process times out or if there was a temporary issue 
              with connecting to Stripe. Your information is safe and secure.
            </p>
          </Alert>

          <div className="d-grid gap-2">
            <Button variant="primary" size="lg" onClick={handleTryAgain}>
              Try Setup Again
            </Button>
            <Button variant="outline-secondary" onClick={() => navigate("/auth/referrals")}>
              Go to Referral Dashboard
            </Button>
            <Button variant="link" onClick={() => navigate("/auth")}>
              Back to Dashboard
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
} 